// The `Discounts` component displays terms and conditions related to a birthday discount offer.
// It iterates over sections of content, rendering each section's title and its respective content.
// Each content item is numbered, and any highlighted text is displayed with a special style, either
// as a link or plain text. The component supports dynamic rendering of answers, with the ability to
// highlight specific text or link it to external URLs. A horizontal line separates each section.
// The component is styled with Tailwind CSS for layout and design, providing a clear and readable
// structure for the terms.

import React from 'react';
import { Answer, BirthdayDiscount, Section } from 'types/next';

interface TermsAndConditionProps {
  agContent: BirthdayDiscount;
}

const Discounts = ({ agContent }: TermsAndConditionProps) => {
  return (
    <div className="Terms and Condition">
      <h2 className="mb-30 text-start text-36 font-bold">{agContent?.name}</h2>
      <div>
        {agContent?.sections?.map((discount: Section, sectionIndex: number) => {
          return (
            <div key={sectionIndex}>
              <h3 className="pb-20 text-28 font-semibold">{discount?.sectionTitle}</h3>
              <div>
                {discount?.content?.map((content, contentIndex) => (
                  <div key={contentIndex}>
                    <div className="flex">
                      <span className="mr-2 mt-5 text-16 font-bold">{contentIndex + 1}.</span>{' '}
                      <div>
                        {content?.answer?.map((segment: Answer, answerIndex: number) => (
                          <p key={answerIndex} className="answer text-16 font-normal leading-7 tracking-wide">
                            {segment.highlight ? (
                              segment.link ? (
                                <a
                                  href={segment.link}
                                  className="highlighted-link cursor-pointer pe-3 ps-3 font-bold text-[#1dce8f] underline hover:text-[#1dce8f]"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {segment.text}
                                </a>
                              ) : (
                                <span className="highlighted-text pe-1 ps-1 font-bold">{segment.text}</span>
                              )
                            ) : (
                              <span>{segment.text}</span>
                            )}
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <hr className="my-20" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Discounts;
